import React from 'react';
import Icon from './Icon';
import {IconProps} from './IconProps';

export default function IconListMove({className, height, title}: IconProps) {
  return (
    <Icon className={className} height={height} title={title}>
      M2 4.25C2 3.83579 2.33579 3.5 2.75 3.5H17.25C17.6642 3.5 18 3.83579 18 4.25C18 4.66421 17.6642 5 17.25
      5H2.75C2.33579 5 2 4.66421 2 4.25ZM2 10.25C2 9.83579 2.33579 9.5 2.75 9.5H17.25C17.6642 9.5 18 9.83579 18 10.25C18
      10.6642 17.6642 11 17.25 11H2.75C2.33579 11 2 10.6642 2 10.25ZM2.75 15.5C2.33579 15.5 2 15.8358 2 16.25C2 16.6642
      2.33579 17 2.75 17H17.25C17.6642 17 18 16.6642 18 16.25C18 15.8358 17.6642 15.5 17.25 15.5H2.75Z
    </Icon>
  );
}
